module.exports = __webpack_public_path__ + "static/media/trash.ebd81dbc.png";